export default "__VITE_ASSET__cf0083d4__"